var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "katalog" }, [
    _c("div", { staticClass: "box p-3" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: _vm.image, alt: _vm.title, title: _vm.title }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "h3 mt-3" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "text-cuttet",
        domProps: { innerHTML: _vm._s(_vm.desc) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "download-box" }, [
        _c(
          "div",
          {
            staticClass: "btn btn-primary btn-block",
            on: {
              click: function($event) {
                return _vm.openModal(_vm.uuid)
              }
            }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$translate("Woerner::Template.globalDownload")) +
                "\n            "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "katalog_" + _vm.uuid,
          tabindex: "-1",
          "aria-labelledby": _vm.title,
          "aria-hidden": "true"
        }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h3", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("table", { staticClass: "table" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.pagesList, function(page) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(page.katalogseite) +
                            "\n                                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "d-block btn btn-outline-primary",
                            attrs: { href: page.link, target: "_blank" }
                          },
                          [
                            _c("i", { staticClass: "fa fa-file-pdf-o" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$translate(
                                    "Woerner::Template.globalDownload"
                                  )
                                ) +
                                "\n                                    "
                            )
                          ]
                        )
                      ])
                    ])
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$translate("Woerner::Template.globalClose"))
                  )
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }